import { Button, Input } from "antd";
import React, { useContext } from "react";
import { SearchOutlined } from "@ant-design/icons";

import QuickbooksContext from "../../context/QuickbooksContext";

const { Search } = Input;

export const SearchInput = ({
  onSearch,
  placeholder,
  style,
}: {
  onSearch: (value: string) => void;
  placeholder?: string;
  style?: React.CSSProperties;
}) => {
  const { searchQuery, onChangeSearchQuery } = useContext(QuickbooksContext);

  return (
    <Search
      placeholder={placeholder || "Search"}
      allowClear
      value={searchQuery}
      style={{
        ...style,
        marginTop: 4,
      }}
      onChange={(e) => onChangeSearchQuery(e.target.value)}
      size="middle"
      onSearch={onSearch}
      enterButton={
        <Button
          type="default"
          icon={<SearchOutlined />}
          disabled={!searchQuery}
          style={{ cursor: !searchQuery ? "not-allowed" : "pointer" }}
        ></Button>
      }
    />
  );
};
